import { useEffect, useRef } from "react";

const useOutsideClick = (refs, callback, options = {}) => {
    const {event = 'mousedown', enabled = true} = options;

    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    useEffect(() => {
        if (!enabled) return;
        const refArray = Array.isArray(refs) ? refs : [refs];
        const handleClick = (e) => {
            const isOutside = refArray.every(ref => ref?.current && !ref.current.contains(e.target));
            if (isOutside) {
                callbackRef.current(e);
            }
        };

        document.addEventListener(event, handleClick);
        return () => {
            document.removeEventListener(event, handleClick);
        };
    }, [event, enabled, refs]);
};

export default useOutsideClick;
